import { Reveal } from "../landing/shared";

const STEPS = [
  { num: "01", title: "Order", copy: "Get your kit delivered to your door." },
  { num: "02", title: "Use", copy: "Rest your feet on the stool while on the toilet." },
  { num: "03", title: "Consult", copy: "Book your free counselling with Dr. Burhan Shaikh." },
];

const HowTo = () => (
  <section data-testid="how-to-section" className="bg-beige py-12 sm:py-16">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">How it works</p>
      </Reveal>
      <div className="mt-8 grid gap-6 sm:grid-cols-3 sm:gap-8">
        {STEPS.map(({ num, title, copy }, i) => (
          <Reveal key={num} delay={0.08 + i * 0.1}>
            <div className="flex items-start gap-4" data-testid={`how-to-step-${num}`}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/50 bg-ivory font-serif text-lg italic text-gold">
                {num}
              </span>
              <div>
                <h3 className="font-sans text-base font-extrabold uppercase tracking-[0.08em] text-navy">
                  {title}
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-charcoal/75">{copy}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowTo;
